import {siteGroup} from "@signals";
import {batch} from "@preact/signals-react";
import React from 'react'
import {BACKEND_APIS} from "../../../../@constants";
import {AutocompleteAsyncSeeker} from "@ui-seeker/core";

export default function AppCommonFiltersSiteGroupAutocomplete({ ...props }) {
    return <AutocompleteAsyncSeeker
        label={"Site Group"}
        placeholder={"All site Group"}
        urlAjax={`${BACKEND_APIS.CRUD}/user/sites_group?selectorFormat=true`}
        value={siteGroup.value || null}
        onChange={e => batch(() => {
            siteGroup.value = e.target.value
        })}
        {...props}
    />
}